import React from 'react';

function useSearchRefresh() {
  const refreshRef = React.useRef<(() => Promise<void>) | null>(null);

  const refresh = React.useCallback(async () => {
    await refreshRef.current?.();
  }, []);

  return {
    refreshRef,
    refresh,
  };
}

export default useSearchRefresh;
